import { yupResolver } from '@hookform/resolvers/yup';
import { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { CabinetContext } from '../../context';
import { SET_FORM, SET_STEP } from '../../context/types';

export default () => {
  const {
    dispatch,
    state: { form, step }
  } = useContext(CabinetContext);
  const goNext = () => {
    dispatch({ type: SET_STEP, payload: step + 1 });
  };
  return { goNext };
};

const schema = yup.object({
  fullName: yup.string().required(' اقل عدد احرف 5 الحقل مطلوب').min(5),
  education: yup.object().required('الحقل مطلوب'),
  birthdate: yup.string().required('الحقل مطلوب'),
  // educationCertAttachCode: yup.object().required(' الحقل مطلوب ويجب حجم الصوره اقل من2 ميجابايت'),
  phoneNo: yup
    .string()
    .required('الحقل مطلوب')
    .matches(/^07[5789]{1}[0-9]{8}$/, 'رقم الهاتف يجب ان يتكون من 11 رقم و يبدأ ب 07'),
  phoneNo2: yup
    .string()
    .required('الحقل مطلوب')
    .matches(/^07[5789]{1}[0-9]{8}$/, 'رقم الهاتف يجب ان يتكون من 11 رقم و يبدأ ب 07')
});
